import "./BreadcrumbsNav.css";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import useBreadcrumbs from "use-react-router-breadcrumbs";

import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";

const BreadcrumbsNav = () => {
  const breadcrumbs = useBreadcrumbs();

  return (
    <Breadcrumbs
      separator={null}
      aria-label="breadcrumb"
      sx={[
        (theme) => ({
          zIndex: 100,
          backgroundColor: "background",
          [theme.breakpoints.down("lg")]: {
            marginLeft: "1rem",
          },
        }),
        {
          "& ol": {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 0,
            "@media (max-width: 1330px)": {
              flexDirection: "row",
            },
          },
          "& li": {
            margin: 0,
            paddingLeft: 0.3,
            lineHeight: 1,
          },
        },
      ]}
    >
      {breadcrumbs.slice(1).map(({ match }, index, slicedBreadcrumb) => {
        // Use last segment of pathname instead of breadcrumbText
        const pathSegments = match.pathname.split("/");
        const lastSegment = pathSegments[pathSegments.length - 1];
        const decodedText = decodeURIComponent(lastSegment);
        let normalizedText = decodedText.replace(/\s+/g, " ").trim();

        if (normalizedText.toLowerCase() === "home") return null;

        let linkTo = match.pathname;

        if (
          ["sales", "coordination", "ifc", "hvac", "design"].includes(
            normalizedText.toLowerCase(),
          )
        ) {
          linkTo = "/home";

          // SALES -> Sales
          normalizedText =
            normalizedText.charAt(0).toUpperCase() +
            normalizedText.slice(1).toLowerCase();
        }

        const prevCrumb = slicedBreadcrumb[index - 1]?.breadcrumb;
        const prevText =
          typeof prevCrumb === "string"
            ? prevCrumb
            : React.isValidElement(prevCrumb)
              ? prevCrumb.props.children
              : "";

        if (
          ["sales", "coordination", "ifc", "hvac", "design"].includes(
            prevText.toLowerCase(),
          )
        ) {
          linkTo = `/home/${encodeURIComponent(normalizedText)}`;
        }

        const isLast = index === breadcrumbs.slice(1).length - 1;

        return (
          <Link
            key={index}
            underline="hover"
            sx={{
              color: "title.secondary",
              fontSize: "0.7rem",
              fontWeight: "bold",
              pointerEvents: isLast ? "none" : "auto",
            }}
            component={RouterLink}
            to={linkTo}
          >
            {normalizedText} {!isLast && "/"}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default BreadcrumbsNav;
